import { ServiceTokens } from "$src/domain/ServiceTokens";
import { Customer } from "$src/domain/customers/Customer";
import { CustomerIdentifier } from "$src/domain/customers/CustomerIdentifier";
import * as ICustomerRepository from "$src/domain/customers/ICustomerRepository";
import { inject, injectable } from "tsyringe";

@injectable()
export class UpdateCustomer {
    
    constructor(@inject(ServiceTokens.CustomerRepository) private customerRepository: ICustomerRepository.ICustomerRepository) {}

    async execute(groupStoreId: number, data: Customer): Promise<CustomerIdentifier> {

        var identifier = await this.customerRepository.updateCustomer(groupStoreId, data);

        return identifier;
    }
}

export const UpdateCustomerToken = Symbol('UpdateCustomerToken');